<template>
	<div class="i-surveys-result-list-item">
		<div class="item-main">
			<div class="title">
				<div
					class="status"
					:class="reviewStatusTag"
					style="white-space: nowrap"
				>
					{{ reviewStatus }}
				</div>
				<div class="title--inner van-ellipsis">
					{{ item.surveyFormDTO.title }}
				</div>
			</div>
			<div class="desc">
				<div class="date">{{ updateDate }}</div>
				<div class="recognize-code">
					<span class="line">|</span>识别码：{{
						item.recognizeCode || "-"
					}}
				</div>
			</div>
			<div class="error-message" v-if="item.reviewStatus == 3">
				不通过原因：{{ item.reviewComment }}
			</div>
		</div>
		<div class="item-action van-hairline--bottom">
			<van-button
				v-if="[10, 11, 13].includes(item.reviewStatus)"
				@click="handleGeneratePDF"
				>生成PDF</van-button
			>
			<!-- <van-button
				v-if="
					(item.reviewStatus == 4 || item.reviewStatus == 2) &&
					item.surveyFormDTO.isConvertPpt == 1 &&
					item.pptGenStatus
				"
				@click="handleAgianGeneratePPT"
				>再次下发PPT</van-button
			>
			<van-button
				v-if="
					(item.reviewStatus == 4 || item.reviewStatus == 2) &&
					item.surveyFormDTO.isConvertPpt == 1 &&
					!item.pptGenStatus
				"
				@click="handleGeneratePPT"
				>生成PPT</van-button
			> -->
			<van-button
				v-if="
					(item.reviewStatus == 4 || item.reviewStatus == 2) &&
					item.surveyFormDTO.isConvertPpt == 1
				"
				@click="handleViewDownloadPPT"
				>查看下载PPT</van-button
			>
			<van-button
				type="primary"
				v-if="item.reviewStatus == 3"
				@click="handleClick"
				>修改</van-button
			>
			<van-button
				type="primary"
				v-if="item.reviewStatus == 0"
				@click="handleClick"
				>编辑</van-button
			>
			<van-button
				v-if="[1, 2, 4, 10, 11, 13, 12].includes(item.reviewStatus)"
				@click="handleClick"
				>查看内容</van-button
			>
			<van-button
				v-if="
					[2, 4, 12].includes(item.reviewStatus) &&
					item.surveyFormDTO.followSetting
				"
				@click="clickFollow"
				>随访<span class="red-drop" v-if="item.redDot"></span
			></van-button>
			<van-button
				type="primary"
				@click="handleChange"
				v-if="[10, 13].includes(item.reviewStatus)"
				>{{
					item.reviewStatus == 10 ? "去上传" : "修改执行"
				}}</van-button
			>
		</div>
		<GeneratePptDialog ref="refGeneratePptDialog" />
		<GeneratePdfDialog ref="refGeneratePdfDialog" />
	</div>
</template>

<script>
import GeneratePptDialog from "./generate-ppt-dialog.vue";
import GeneratePdfDialog from "./generate-pdf-dialog.vue";
export default {
	components: { GeneratePptDialog, GeneratePdfDialog },
	props: {
		item: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		statusMap() {
			return this.$status.iSurveys;
		},
		reviewStatusTag() {
			return this.statusMap.reviewStatusTag[this.item.reviewStatus];
		},
		reviewStatus() {
			return this.statusMap.reviewStatus[this.item.reviewStatus];
		},
		handleActionText() {
			if ([0, 3].includes(this.item.reviewStatus)) {
				return "编 辑";
			}
			return "查 看";
		},
		updateDate() {
			return (this.item.firstSubmitReviewTime || this.item.createTime)
				.split(" ")[0]
				.split("-")
				.join("·");
		},
	},
	methods: {
		handleClick() {
			this.$emit("click", {
				value: this.item,
			});
		},
		handleChange() {
			this.$emit("change", {
				value: this.item,
			});
		},
		clickFollow() {
			this.$router.push(`/i-surveys/follow/list/${this.item.id}`);
		},
		handleAgianGeneratePPT() {
			this.$dialog
				.confirm({
					title: "提示",
					message: `此表单已生成过PPT，每份PPT请勿重复提交上传，是否确认再次生成？`,
					showCancelButton: true,
					confirmButtonText: "确认",
					cancelButtonText: "取消",
				})
				.then(() => {
					this.handleGeneratePPT();
				})
				.catch(() => {});
		},
		handleGeneratePPT() {
			this.$refs.refGeneratePptDialog.init(this.item);
		},
		handleGeneratePDF() {
			this.$refs.refGeneratePdfDialog.init(this.item);
		},
		handleViewDownloadPPT() {
			this.$router.push(`/i-surveys/ppt-preview/${this.item.id}`);
		},
	},
};
</script>
